export const SET_MENU_MANAGEMENT_REMOTE_CONFIG =
  'SET_MENU_MANAGEMENT_REMOTE_CONFIG';
